// extracted by mini-css-extract-plugin
export var discard = "_32-3";
export var muiTooltipTooltip = "_32-5";
export var notificationBar = "_32-2";
export var saveButtonHoverSlotWrapper = "_32-4";
export var show = "_32-1";
export var spacer = "_32-0";